const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
/** "2026-10-15" (or an RFC 3339 timestamp) → fractional year (2026.79), or null when empty or unparseable. */ export function toYear(day) {
    const m = /^(\d{4})-(\d{2})(?:-(\d{2}))?/.exec(day);
    if (!m) return null;
    const year = Number(m[1]);
    const month = Number(m[2]) - 1;
    const d = m[3] ? Number(m[3]) - 1 : 0;
    const dim = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    return year + (month + d / dim) / 12;
}
export const dateToYear = (d)=>toYear(d.toISOString().slice(0, 10)) ?? d.getUTCFullYear();
/** Calendar year of a day string, or null. */ export function yearOf(day) {
    const t = toYear(day);
    return t === null ? null : Math.floor(t + 1e-9);
}
/** 2026.79 → "Oct 2026". */ export function monthYear(t) {
    const y = Math.floor(t + 1e-9);
    return `${MONTHS[Math.min(11, Math.floor((t - y) * 12 + 1e-6))]} ${y}`;
}
export const holderLabel = (r)=>r.holderLabel || (r.holderKind === 'us' ? 'Us' : 'Competitor');
export const roundEnd = (r)=>r.optionsEnd || r.popEnd;
